import { lens } from '@core/zustand/lens'

import type { ModalAction } from './actions'
import { createModalActions } from './actions'
import type { IModalState } from './state'
import { createModalState } from './state'

export const MODAL_SLICE_KEY = 'modal'

export interface IModalSlice<Configs> {
  [MODAL_SLICE_KEY]: IModalState<Configs> & {
    actions: ModalAction<Configs>
  }
}

/**
 *
 */
export function createModalSlice<Configs>(): IModalSlice<Configs> {
  return {
    [MODAL_SLICE_KEY]: lens((set) => ({
      ...createModalState<Configs>(),
      actions: createModalActions<Configs>(set),
    })),
  }
}
